angular.module('rjmNg.services').factory 'updateService', [
  "$http"
  "$q"
  "$url"
  "dateService"
  ($http, $q, $url, dateService) ->

    # This is needed because the response is an object instead of an array, otherwise
    # we could have used ng-resource
    get : (clientId) ->
      deferred = $q.defer()
      promise = $http
        method: "GET"
        url: $url("/client/#{clientId}/fullupdateinfo")
      .then ({data}) ->
        deferred.resolve(data)
      .catch () ->
        deferred.reject()
      return deferred.promise

    getCompletedUpdateUpToDateThrough : (updateInfo) ->
      endTime = updateInfo.lastCompletedUpdateJobEndTime
      if endTime
        return @_hourTimeFormat endTime, updateInfo.timezoneAbbreviation

    getDataUpToDateThrough : (updateInfo) ->
      startTime = updateInfo.lastCompletedUpdateJobWithDataSyncStartTime
      if startTime
        return @_hourTimeFormat startTime, updateInfo.timezoneAbbreviation

    _hourTimeFormat : (time, timezone) ->
      return dateService.format(
        @_removeTimeZone(time), 'Hour'
      ) + ": " + timezone

    getCurrentUpdateLength : (updateInfo) ->
      status = "No update is currently running"
      if updateInfo.ongoingUpdateJobStartTime?
        status = "Current update has been running for #{updateInfo.ongoingUpdateJobStartTime}"
      return status

    isCurrentUpdateRunning : (updateInfo) ->
      return updateInfo.ongoingUpdateJobStartTime?

    _removeTimeZone : (date) ->
      date.substr(0,19)
]

